<template>
  <div>
    <div id="campaign-manage" v-if="modeManage">
      <div class="header">MANAGE MY CAMPAIGN</div>
      <div class="main-contain">
        <div class="md-layout">
          <div class="md-layout-item0" style="width:350px;">
            <md-card class="campaign-list-card" id="campaign-manage-list">
              <md-card-header>
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-field class="campaign-selection-options select-filter-status">
                      <md-select v-model="selectedStatus">
                        <md-option value="All">Show all</md-option>
                        <md-option value="Active">Active</md-option>
                        <md-option value="Ready">Ready</md-option>
                        <md-option value="Pending">Pending</md-option>
                        <md-option value="Draft" v-if="!isApprover&& my_campaign" >Darft</md-option>
                        <md-option value="Expired" v-if="!isApprover && my_campaign">Expired</md-option>
                        <md-option value="Reject" v-if="!isApprover ">Reject</md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item" style="text-align:right">
                    <!-- <md-button class="icon-filter md-icon-button" @click="showDialogFilter()">
                      <md-icon v-bind:class="{ 'has-filter': hasFilter }">filter_list</md-icon>
                    </md-button> -->
                   <md-checkbox v-model="my_campaign" class="md-primary" @change="myCampaign">My Campaign</md-checkbox>
                  </div>
                </div>
              </md-card-header>
              <md-card-content>
                <md-field class="md-search-box" md-clearable>
                  <i class="md-icon material-icons">search</i>
                  <md-input v-model="searchKeyword" type="text" placeholder="Search my campaign..."></md-input>
                </md-field>

                <div class="campaign-manage-list-box">
                  <md-list class="campaign-list">
                    <md-list-item v-for="(item,index) in eventsData" :key="index">
                      <span class="md-list-item-text" @click.stop="viewCampaign(item.id)">
                        <div class="md-layout">
                          <div class="md-layout-item">
                            <div class="campaign-item-code">{{item.code}}</div>
                            <div class="campaign-item-title">{{item.title}}</div>
                          </div>
                          <div class="md-layout-item">
                            <div
                              class="campaign-status-label"
                              style="float:right"
                              :class="getStatusClass(item.status)"
                            >{{item.status}}</div>
                          </div>
                        </div>
                      </span>

                      <md-menu
                        md-align-trigger>
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon>more_vert</md-icon>
                        </md-button>
                        <md-menu-content style="z-index:20;" v-if="!isApprover && isOwner(item) && (isEdit || isDelete)">
                          <!-- <md-menu-item>Send to approve</md-menu-item> -->
                          <!-- <md-menu-item  disabled @click="data = 'click disabled'">Recall</md-menu-item> -->
                          <md-menu-item
                            @click="editCampaign(item.id)"
                            v-if="!isPending(item) && isEdit && !isExpired(item)"
                          >Edit</md-menu-item>
                          <!-- <md-menu-item>Duplicate</md-menu-item> -->
                          <md-menu-item
                            @click="duplicateCampaign(item.id)"
                            v-if="!isPending(item) && isEdit == true"
                          >Duplicate</md-menu-item>
                          <md-menu-item
                            @click="sendToApproveCampaign(item.id)"
                            v-if="!isReject(item) && !isPending(item) && isEdit && !isExpired(item)"
                          >Send Approve</md-menu-item>
                          <md-menu-item
                            @click="recallCampaign(item.id)"
                            v-if="isPending(item) && isEdit && !isExpired(item)"
                          >Recall</md-menu-item>

                          <md-menu-item
                            @click="deleteCampaign(item.id)"
                            v-if="!isPending(item) && isDelete"
                          >Delete</md-menu-item>

                          <!-- <md-menu-item
              @click="approveCampaign(Info._id)"
              v-if="permit.acl['campaign'].menus['manage'].approve == true && !Expired"
            >Approve</md-menu-item>
            <md-menu-item
              @click="rejectCampaign(Info._id)"
              v-if="permit.acl['campaign'].menus['manage'].approve == true && !Expired"
                          >Reject</md-menu-item>-->
                        </md-menu-content>
                      </md-menu>
                      <!-- <md-menu md-size="auto" :md-offset-x="127" :md-offset-y="-36" >
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon class="md-primary more-menu">more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                          <md-menu-item @click="viewCampaign(item.id)">View</md-menu-item>
                          <md-menu-item
                            @click="editCampaign(item.id)"
                            v-if="permit.acl['campaign'].menus['manage'].edit == true && !isExpired(item)"
                          >Edit</md-menu-item>
                          <md-menu-item
                            @click="deleteCampaign(item.id)"
                            v-if="permit.acl['campaign'].menus['manage'].delete == true && !isExpired(item)"
                          >Delete</md-menu-item>
                        </md-menu-content>
                      </md-menu>-->
                    </md-list-item>
                  </md-list>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item" style="margin-left:10px;">
            <md-card class="calendar-card">
              <md-card-header>
                <div class="md-layout md-gutter">
                  <div class="md-layout-item">
                    <div class="title">Calendar View</div>
                  </div>
                  <div class="md-layout-item" style="text-align:right">
                    <button class="btn-this-month" @click="goThisMonth()">This Month</button>

                    <md-field class="campaign-selection-options" style="width:100px;">
                      <md-select v-model="viewMonth" @md-selected="changeViewMonth">
                        <md-option value="3">3-month</md-option>
                        <md-option value="6">6-month</md-option>
                        <md-option value="12">12-month</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
              </md-card-header>
              <md-card-content>
                <Calendar
                  ref="cal"
                  :viewMonth="viewMonth"
                  :eventData="eventsData"
                  v-on:clickEvent="viewCampaign"
                ></Calendar>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>

      <dlgFilter :show="showFilter" @cancel="showFilter = $event"></dlgFilter>
    </div>

    <DialogInfomation
      :showDialog="showDialogInfo"
      :dataCampaign="dataCampaignInfo"
      @onClose="showDialogInfo = $event"
      @editCampaign="editCampaign"
      @duplicateCampaign="duplicateCampaign"
      @recallCampaign="recallCampaign"
      @sendToApproveCampaign="sendToApproveCampaign"
      @deleteCampaign="deleteCampaign"
      @onApprove="approveCampaign"
      @onReject="rejectCampaign"
    ></DialogInfomation>

    <div id="formEdit" v-if="modeEdit">
      <formCampaign
        :Mode="'edit'"
        :title="'EDIT A CAMPAIGN'"
        :data="dataCampaignInfo"
        @onCancel="cancelEditCampaign"
        @onSave="formSave"
        @onConfirmEditPublish="formSavePublish"
        :goToStep="selectStepEdit"
      ></formCampaign>
    </div>
    <div id="formDuplicate" v-if="modeDuplicate">
      <formCampaign
        :Mode="'duplicate'"
        :title="'DUPLICATE A CAMPAIGN'"
        :data="dataCampaignInfo"
        @onCancel="cancelEditCampaign"
        @onSaveToDraft="saveToDraft"
        @onSendToApprove="sendToApprove"
      ></formCampaign>
    </div>

    <!-- <infomation
      ref="Info"
      :dataCampaign="dataCampaignInfo"
      v-on:editCampaign="editCampaign"
      v-on:deleteCampaign="deleteCampaign"
      v-on:duplicateCampaign="duplicateCampaign"
      v-on:recallCampaign="recallCampaign"
      v-on:sendToApproveCampaign="sendToApproveCampaign"
    ></infomation>-->
    <md-dialog-confirm
      :md-active.sync="dlgConfirmEdit"
      md-title="Campaign is Active?"
      md-content="Are you sure you want to edit this Campaign?"
      md-confirm-text="Edit"
      md-cancel-text="Cancel"
      @md-confirm="confirmEditCampaign"
      @md-opened="setLayerDialog"
    />

    <md-dialog-confirm
      :md-active.sync="dlgConfirmDelete"
      md-title="Delete a campaign?"
      md-content="Are you sure."
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="confirmDeleteCampaign"
      @md-opened="setLayerDialog"
    />
  </div>
</template>

<script>
import CalendarView from "./manage/calendar";
import dlgFilter from "./manage/dlgFilter";
import CampaignService from "@/services/campaign";
import Infomation from "./manage/infomation";

import DialogInfomation from "./manage/dlgInfomation";

import formCampaign from "./share/form-campaign/form-campaign";

import CoreService from "@/services/core";
import CipherService from "@/services/cipher";

import router from "@/router";

export default {
  name: "campaign-manage",
  components: {
    Calendar: CalendarView,
    Infomation,
    formCampaign,
    dlgFilter,
    DialogInfomation
    // Stepper
  },
  data() {
    return {
      modeManage: true,
      modeEdit: false,
      modeDuplicate: false,
      selectFilter: [
        {
          label: "All",
          value: 0,
          selected: true
        },
        {
          label: "Active",
          value: 1
        },
        {
          label: "Ready",
          value: 2
        },
        {
          label: "Pending",
          value: 3
        },
        {
          label: "Draft",
          value: 4
        },
        {
          label: "Expired",
          value: 5
        }
      ],
      campaign: [],
      viewMonth: 6,
      events: [],
      eventsData: [],
      //drawer
      showSidepanel: false,
      // showDialogFilter: false,

      selectedStatus: "All",

      dataSearchProducts: [],
      dataSearchCustomers: [],

      selectedFilterProducts: [],
      selectedFilterCustomers: [],

      isLoading: false,

      showInfo: false,
      searchKeyword: "",

      dataCampaignInfo: {},

      hasFilter: false,
      selectStepEdit: 1,

      dlgConfirmDelete: false,
      deleteCampaignID: "",

      showFilter: false,

      dlgConfirmEdit: false,

      showDialogInfo: false,

      my_campaign: true,
      my_view: 0
    };
  },
  watch: {
    searchKeyword: function() {
      this.searchCampaign();
    },
    selectedStatus: function() {
      this.searchCampaign();
    }
  },
  created() {
    this.selectAllFilter();
    // this.loadEvents();
    this.searchCampaign();
  },
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isApprover() {
      if (this.permit.acl["campaign"].menus["manage"].approve == true)
        return true;
      else false;
    },
    user() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isEdit(){
      if (this.permit.acl['campaign'].menus['manage'].edit == true) return true;
      else return false;
    },
    isDelete(){
      if (this.permit.acl['campaign'].menus['manage'].delete == true) return true;
      else return false;
    }
  },
  methods: {
    isExpired(item) {
      if (item.status == "Expired") return true;
      else return false;
    },
    isOwner(item){
      // console.log(item);
      if (this.user.username == item.createby) return true;
      else return false;
    },
    isPending(item){
      if (item.status == "Pending") return true;
      else return false;
    },
    isReject(item){
      if (item.status == "Reject") return true;
      else return false;
    },
    showDialogFilter() {
      this.showFilter = true;
    },
    loadEvents() {
      let _self = this;
      this.eventsData = [];

      CampaignService.getAllEvents(0).then(response => {
        response.forEach(data => {
          this.eventsData.push({
            id: data._id,
            code: data.campaign_code,
            title: data.campaign_title,
            start: data.startdate,
            end: data.enddate,
            status: data.campaign_status,
            createby: data.createby
          });

          setTimeout(function() {
            _self.$refs.cal.rerender();
          }, 100);
        });
        //this.events = response;
      });
    },
    selectAllFilter() {
      let copy = JSON.parse(JSON.stringify(this.selectFilter));
      copy.forEach(d => !d.disabled && (d.selected = true));
      this.selectFilter = copy;
    },
    changeViewMonth(total_month) {
      this.viewMonth = parseInt(total_month);
    },
    goThisMonth() {
      this.$refs.cal.goThisMonth();
    },
    changedFilter(item) {
      if (item.label !== "All") {
        let count_selected = 0;
        this.selectFilter.forEach(d => d.selected == true && count_selected++);
        if (count_selected < this.selectFilter.length)
          this.selectFilter[0].selected = false;
        //console.log(count_selected)
        //if(item.selected == false) this.selectFilter[0].selected = false;
        return;
      }
      let copy = this.selectFilter;
      copy.forEach(d => !d.disabled && (d.selected = item.selected));

      this.selectFilter = copy;
    },
    customSelectedText(selected, defaultFn) {
      let hasAll = false;
      selected.every(s => {
        if (s.label === "All") {
          hasAll = true;
          return false;
        }
        return true;
      });
      if (hasAll) {
        return "All";
      }

      return defaultFn(selected);
    },
    opendRightPanel() {
      setTimeout(function() {
        var x = document.getElementsByClassName("md-overlay");
        x[0].style.background = "none";
      }, 50);
    },

    // limitText (count) {
    //   return `and ${count} other countries`
    // },
    asyncFindProducts(query) {
      this.isLoading = true;
      CoreService.searchProducts(query).then(response => {
        this.dataSearchProducts = response;
        //console.log(response);
        this.isLoading = false;
      });
    },
    asyncFindCustomers(query) {
      this.isLoading = true;
      CoreService.searchCustomers(query).then(response => {
        this.dataSearchCustomers = response;
        //console.log(response);
        this.isLoading = false;
      });
    },
    viewCampaign(id) {
      //alert(id);
      CampaignService.getCampaignById(id).then(response => {
        //console.log(response);
        this.dataCampaignInfo = response;

        // this.$refs.Info.showInfo = true;
        this.showDialogInfo = true;
      });
    },

    editCampaign(id) {
      CampaignService.getCampaignById(id).then(response => {
        this.dataCampaignInfo = response;

        if (this.dataCampaignInfo.campaign_status == "Active") {
          this.dlgConfirmEdit = true;
        } else {
          this.showDialogInfo = false;
          this.modeManage = false;
          this.modeEdit = true;
          this.modeDuplicate = false;
        }
      });
    },
    confirmEditCampaign() {
      this.showDialogInfo = false;
      this.modeManage = false;
      this.modeEdit = true;
      this.modeDuplicate = false;
    },
    cancelEditCampaign() {
      this.modeManage = true;
      this.modeEdit = false;
      this.modeDuplicate = false;
    },

    formSave(dataCamp) {
      if (this.modeEdit == true) {
        console.log("edit", dataCamp);

        CampaignService.updateCampaign(dataCamp).then(response => {
          this.searchCampaign();

          this.modeManage = true;
          this.modeEdit = false;
          this.modeDuplicate = false;
        });
      } else if (this.modeDuplicate == true) {
        CampaignService.duplicateCampaign(dataCamp).then(response => {
          this.searchCampaign();

          this.modeManage = true;
          this.modeEdit = false;
          this.modeDuplicate = false;
        });
      }
    },
    formSavePublish(dataCamp) {
      CampaignService.updateCampaignPublish(dataCamp).then(response => {
        this.searchCampaign();

        this.modeManage = true;
        this.modeEdit = false;
        this.modeDuplicate = false;
      });
    },
    trackCampaign(id) {
      alert(id);
    },
    searchCampaign() {
      //console.log(this.searchKeyword,this.selectedStatus,this.selectedFilterProducts,this.selectedFilterCustomers)
      //console.log(this.searchKeyword);
      //if(this.searchKeyword != ""){
      if(this.my_campaign == true){
        this.my_view = 0
      }else{
        this.my_view = 1
      }
      CampaignService.searchCampaigns(
        this.searchKeyword,
        this.selectedStatus,
        this.my_view
      ).then(response => {
        this.eventsData = [];
        response.forEach(data => {
          this.eventsData.push({
            id: data._id,
            code: data.campaign_code,
            title: data.campaign_title,
            start: data.startdate,
            end: data.enddate,
            status: data.campaign_status,
            createby: data.createby
          });

          this.$refs.cal.rerender();
        });
        //console.log(response);
        //this.dataSearchCustomers = response;
        //console.log(response);
        //this.isLoading = false;
      });
      // }
    },
    addFilter() {
      // this.showDialogFilter = false;
      this.searchCampaign();
    },
    checkStatus(status) {
      return status;
    },

    // ,
    // clearAll () {
    //   this.dataSearchProducts = []
    // }
    duplicateCampaign(id) {
      CampaignService.getCampaignById(id).then(response => {
        this.showDialogInfo = false;
        this.dataCampaignInfo = response;

        this.dataCampaignInfo = response;
        this.dataCampaignInfo.campaign_title += " - Copy";
        this.dataCampaignInfo.startdate = "";
        this.dataCampaignInfo.enddate = "";
        this.dataCampaignInfo.join_within = "";
        this.dataCampaignInfo.join_within_dsate = null;

        this.modeManage = false;
        this.modeEdit = false;
        this.modeDuplicate = true;
        this.selectStepEdit = 1;
      });
    },
    getStatusClass(status) {
      switch (status) {
        case "Active":
          return "active";
          break;
        case "Ready":
          return "ready";
          break;
        case "Pending":
          return "pending";
          break;
        case "Draft":
          return "draft";
          break;
        case "Expired":
          return "expired";
          break;
        case "Reject":
          return "reject";
          break;
      }
    },
    deleteCampaign(id) {
      this.dlgConfirmDelete = true;
      this.deleteCampaignID = id;
    },
    confirmDeleteCampaign() {
      CampaignService.deleteCampaign(this.deleteCampaignID).then(response => {
        if (response.status == "success") {
          this.showDialogInfo = false;
          this.loadEvents();
        } else {
          alert(response.message);
        }
      });

      this.deleteCampaignID = "";
    },
    recallCampaign(id) {
      CampaignService.recallCampaign(id).then(response => {
        this.showDialogInfo = false;
        // if(response.status == 'success'){
        this.loadEvents();
        // }
      });
    },
    sendToApproveCampaign(campaign_id) {


        CipherService.getBossCode(this.user.code)
          .then(response => {

            if(response.resource.length > 0)
            {
              // console.log(response.resource);

              let boss_code = response.resource[0].boss_code;

              CampaignService.sendToApproveCampaign(campaign_id,boss_code).then(response => {
                this.showDialogInfo = false;
                // if(response.status == 'success'){
                this.loadEvents();
                // }
              });

            }else{
              console.log('Not found boss_code')
            }
            // this.dataSearchUsers = response.resource;
            // this.$forceUpdate()

          })
          .catch(error => console.log(error));


      // CampaignService.sendToApproveCampaign(id).then(response => {
      //   this.showDialogInfo = false;
      //   // if(response.status == 'success'){
      //   this.loadEvents();
      //   // }
      // });


    },
    saveToDraft(dataCamp) {
      if (dataCamp.sets[0].name == "") dataCamp.sets[0].name = "SET 1";
      delete dataCamp["_id"];
      dataCamp.campaign_status = "Draft";
      CampaignService.createCampaign(dataCamp).then(response => {
        // this.$router.push('/campaign/manage')
        this.loadEvents();

        this.modeManage = true;
        this.modeEdit = false;
        this.modeDuplicate = false;
      });
    },
    sendToApprove(dataCamp) {
      delete dataCamp["_id"];
      dataCamp.campaign_status = "Pending";
      CampaignService.createCampaign(dataCamp).then(response => {
        // this.$router.push('/campaign/manage')
        this.loadEvents();

        this.modeManage = true;
        this.modeEdit = false;
        this.modeDuplicate = false;
      });
    },
    setLayerDialog() {
      //alert('test');//
      var x = document.getElementsByClassName("md-dialog")[1];
      x.style.zIndex = 12;
      var y = document.getElementsByClassName("md-overlay")[1];
      y.style.zIndex = 11;
    },
    approveCampaign(id) {
      CampaignService.approve(id).then(response => {
        this.showDialogInfo = false;
        this.loadEvents();
      });
    },
    rejectCampaign(id) {
      CampaignService.reject(id).then(response => {
        this.showDialogInfo = false;
        this.loadEvents();
      });
    },
    myCampaign(value){
      // console.log("campaign=>", value);
      this.searchCampaign();
    }
  }
};
</script>

<style lang="scss">
.campaign-manage-list-box {
  //border: 1px solid rgba(#000, .12);
  height: calc(100vh - 200px);

  overflow-y: auto;

  .campaign-list {
    margin-top: 5px;
    width: 100%;
    display: inline-block;
    vertical-align: top;
    //border: 1px solid rgba(#000, .12);

    .campaign-item-code,
    .campaign-item-title {
      font-size: 12px;
      color: #414141;
    }
  }

  .md-list-item-text {
    cursor: pointer;
    padding-right: 5px;
    padding-left: 20px;
    // &:hover{
    //   background: red;
    // }
  }

  .md-list-item-content {
    padding: 0px !important;
    min-height: 35px;

    &:hover {
      background: rgb(233, 232, 232);
    }
  }
}
</style>

<style lang="scss" scoped>
#campaign-manage {
  //height: 100%;
  padding: 20px 20px 0px 20px;
  width: 100%;
  min-width: 1000px;

  .header {
    font-family: Lato;
    font-size: 18px;
    color: #797979;
    margin-bottom: 10px;
  }

  .right-panel {
    width: 500px;
  }
}

.filter-options {
  width: 90px;
}

.md-select-menu .md-option:focus:not([selected]) {
  background: rgb(238, 238, 238);
}

.filter-status {
  display: inline-block;
  //width: 90px;
  min-height: 30px;
  padding-top: 0px;
  background: #efefef;
  border-radius: 3px;

  font-size: 12px !important;

  &.md-theme-default:after {
    background-color: transparent;
  }
  &.md-theme-default:before {
    background-color: transparent;
  }
}

.calendar-month-select {
  display: inline-block;
  width: 90px;
  min-height: 30px;
  padding-top: 0px;
  background: #efefef;
  border-radius: 3px;

  .md-select-value {
    font-size: 12px !important;
  }

  &.md-theme-default:after {
    background-color: transparent;
  }
  &.md-theme-default:before {
    background-color: transparent;
  }
}

// .md-layout-item {
//   height: 40px;

//   &:after {
//     width: 100%;
//     height: 100%;
//     display: block;
//     background: md-get-palette-color(green, 200);
//     content: " ";
//   }
// }

#campaign-manage-list {
  .select-filter-status {
    margin-left: 20px;
    margin-top: 15px;
    width: 120px;
  }

  .md-card-header {
    padding: 0px 0px 10px 0px;
    height: 50px;

    .icon-filter {
      margin-right: 10px;
      margin-top: 5px;

      .has-filter {
        color: blue;
      }
    }
  }

  .md-search-box {
    //margin: 12px 0 15px 0;
    padding-top: 0px;
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    width: 310px;
    border-radius: 3px;
    min-height: 36px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
      0 1px 1px -2px rgba(0, 0, 0, 0);

    .md-icon.material-icons {
      margin-left: 17px;
      padding-top: 8px;
      color: rgba(0, 0, 0, 0.54);
    }

    .md-input {
      height: 36px;
      margin-right: 20px;
    }

    &.md-field > .md-icon:after,
    &.md-field:after,
    &.md-field:before {
      content: none;
    }
  }

  .campaign-status-label {
    text-align: center;
    vertical-align: middle;
    padding: 3px;
    width: 50px;
    height: 18px;
    border-radius: 2px;
    font-size: 10px;
    font-family: Roboto;
    font-weight: bold;
    color: white;
    margin-top: 5px;

    &.active {
      background: #3b62c1;
    }
    &.ready {
      background: #52b6b0;
    }
    &.pending {
      background: #ebc26b;
    }
    &.draft {
      background: #a8a8a8;
    }
    &.expired {
      background: #e1e1e1;
    }
    &.reject {
      background: #c13b82;
    }
  }

  .more-menu {
    color: black;
  }
}

.campaign-list-card {
  height: calc(100vh - 80px);

  .md-card-content {
    padding: 0px;
  }
}

.calendar-card {
  height: calc(100vh - 80px);

  .md-card-content {
    //height: '100%';//calc(100vh - 230px);
    padding: 0px;
  }

  .md-card-header {
    height: 50px;
    padding-top: 10px !important;
    .title {
      //font-size: 12px;
      margin-top: 10px;
      font-style: Lato, Bold;
      font-weight: 500;
      color: #414141;
    }
  }
}
</style>